const About = theme => {
  return {
    background: {
      backgroundImage:
        ' linear-gradient(to right top, #8fcf68, #00c19a, #00a9e4, #0083ff, #7633d9)',
    },
    foreground: {
      color: 'rgba(255,255,255,.7)'
    }
  }
}

export default About



// WEBPACK FOOTER //
// ./src/styles/mixins/gradients/about.js